export default {
  errorListContainer: 'ml-2! list-disc!	list-inside!	',
  errorListLine: 'list-item! text-base! text-black! font-normal!',
  errorRow: 'pt-0! pb-3! px-4! border-none!',
  tableRow: 'border-[#a8c5bf] bg-[#BFDFD8]! nth-1:border-none!',
};
